// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cF","cardHeaderIcon__content":"c-e_cG"};